"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Modal = _interopRequireDefault(require("../Modal/Modal"));
var _Button = require("../../Elements/Button/Button");
var _Text = require("../../Elements/Text/Text");
var _pictogram = _interopRequireDefault(require("../../Elements/pictogram/pictogram"));
var _IconButton = require("../../Clickables/IconButton/IconButton");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ShowcaseModal = ({
  onHide,
  show,
  data,
  size,
  activeItem,
  isRtl,
  modalArgs
}) => {
  const [activeContent, setActiveContent] = (0, _react.useState)(activeItem);
  const handleNext = () => setActiveContent(activeContent + 1 < data.items.length - 1 ? activeContent + 1 : data.items.length - 1);
  const handlePrev = () => setActiveContent(activeContent - 1 >= 0 ? activeContent - 1 : 0);
  const handleActive = index => setActiveContent(index);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
      ...modalArgs,
      ...data,
      show: show,
      onHide: onHide,
      size: size,
      isRtl: isRtl,
      dialogClassName: ['-centerAlign ', 'modal--showcase-content'],
      children: [data.items.map((caseItem, index) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          id: `'ShowCaseContent'${index}`,
          className: `modal-content--showcase-content ${activeContent === index ? 'modal-content--showcase-content--active' : 'modal-content--showcase-content--hide'}`,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default.Header, {
            closeButton: true,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_pictogram.default, {
              className: "-modalImage",
              name: caseItem.icon.name,
              size: caseItem.icon.size
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
              type: "overline",
              content: caseItem.overline,
              isHTML: true
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Title, {
              children: caseItem.title
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Body, {
            children: caseItem.text
          })]
        });
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default.Footer, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "modal--icon-buttons modal--icon-buttons--left",
          children: data.buttonShowPrev ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
            icon: "arrow-downward",
            variant: "plain",
            handleClick: () => {
              handlePrev();
            }
          }) : null
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "modal--dots",
          children: data.items.map((caseItem, index) => {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              "aria-hidden": true,
              className: `modal--dots--dot ${index === activeContent && 'modal--dots--dot--active'}`,
              onClick: () => {
                handleActive(index);
              }
            }, caseItem.title);
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "modal--icon-buttons modal--icon-buttons--right",
          children: activeContent === data.items.length - 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            text: data.buttonLastText,
            variant: data.buttonVariant,
            onClick: onHide
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
            icon: "arrow-downward",
            variant: data.buttonVariant,
            handleClick: () => {
              handleNext();
            }
          })
        })]
      })]
    })
  });
};
var _default = exports.default = ShowcaseModal;
module.exports = exports.default;